import { ALL_REPORTS_PATH } from "../const";

export const REPORT_DISPATCH_PAGE = "dispatch";
export const REPORT_DISPATCH_PATH = `${ALL_REPORTS_PATH}/${REPORT_DISPATCH_PAGE}`;
